import React from 'react';
import CustomTextField from 'components/Fileds/CustomTextFiled';
import CustomTypography from 'components/Fileds/CustomTypography';
import * as Yup from 'yup';
import GenericDialog from '../GenericDialog/GenericDialog';
import { useTheme } from '@mui/material';

const CategorySchema = Yup.object().shape({
  name: Yup.string().required('Category Name is required'),
});

const InventoryCategoriesModal = ({ open, onClose, initialData, onSubmit, loading }) => {
  const isEdit = Boolean(initialData);
  const title = isEdit ? 'Edit Inventory Category' : 'Add New Category';
  const theme = useTheme();
  
  return (
    <GenericDialog
      open={open}
      onClose={onClose}
      title={title}
      initialValues={{ name: initialData?.name || '' }}
      validationSchema={CategorySchema}
      onSubmit={onSubmit}
      submitLabel={isEdit ? 'Update' : 'Save'}
      loading={loading}
      requiredFields={[ 'name' ]}
    >
      {({ values, errors, touched, handleChange, handleBlur }) => (
        <>
          <CustomTypography
              label="Category Name"
              sx={{ fontSize: '14px', fontWeight: 600, color: theme.palette.typographyLabel.main }}
          />
          <CustomTextField
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            placeholder="Enter Category Name"
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && errors.name}
          />
        </>
      )}
    </GenericDialog>
  );
};

export default InventoryCategoriesModal;
